(function () {
  'use strict';

  var tracks = document.querySelectorAll('.ff-marquee__track, .ff-press__track');
  if (!tracks.length) return;

  if (!('IntersectionObserver' in window)) {
    tracks.forEach(function (track) { track.classList.add('liitt-motion-visible'); });
    return;
  }

  var observer = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      entry.target.querySelectorAll('.ff-marquee__track, .ff-press__track').forEach(function (track) {
        track.classList.toggle('liitt-motion-visible', entry.isIntersecting);
      });
    });
  }, { rootMargin: '100px 0px' });

  tracks.forEach(function (track) { observer.observe(track.parentElement); });
})();
